/**************************************************************************************************/
/*   File: /src/app/shared/services/download/download.service.ts                                  */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { catchError, delay, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { SpatialDataTypeEnum } from '../../enums';
import { HeaderService } from '../utils/header.service';
import { GeometricExportInput } from '../../models';

/**
 * The download service
 */
@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  /**
   * The api url for authorization users
   */
  apiUrl = environment.serviceHost;
  /**
   * The api path
   */
  apiPath = environment.apiPath;
  /**
   * The dossiers url
   */
  path = 'portal-dossier';
  /**
   * The geo data type api url
   */
  geoDataTypePath = 'types';

  /**
   * The constructor
   * @param http The http 
   * @param logger the logger
   * @param headerService The header service
   */
  constructor(private http: HttpClient, private logger: NGXLogger, private headerService: HeaderService) {
  }

  /**
   * Prepare the download
   */
  prepareDownload(data: GeometricExportInput): Observable<any> {
    // FIXME
    return this.http.post(`${this.apiUrl}${this.apiPath}export/firePortalExport`, data);
  }

  /**
   * Prepare the download regulations
   */
  prepareDownloadRegulation(ambitoType: number, ambitoCode: string, planCode: string) {
    return this.http.get(
      `${this.apiUrl}${this.apiPath}document/actual-ambito-has-norme?ambitoType=${ambitoType}&ambitoCode=${ambitoCode}&planCode=${planCode}`,
      this.headerService.getHeaders()
    );
  }

  /**
   * Chec the download status
   * @param {number} taskId The task id
   */
  checkDownloadStatus(taskId: number) {
    // FIXME
    return this.http.get(`${this.apiUrl}${this.apiPath}export/status?taskId=${taskId}`);
  }

  /**
   * Get the list of public document
   * @param {string} planCode The plancode
   * @param {SpatialDataTypeEnum} spatialDataTye The spatialData type
   */
  getAllPublicDocuments(planCode: string, spatialDataTye: SpatialDataTypeEnum) {
    return this.http.get(
      `${this.apiUrl}${this.apiPath}portal-public-documents/documents-by-plan-and-spatialtype?planCode=${planCode}&spatialDataType=${spatialDataTye}`,
      this.headerService.getHeaders()
    );
  }

  /**
   * Return the url for download
   * @param {number} taskId the task id
   */
  getGeometricUrl(taskId: number) {
    return `${this.apiUrl}${this.apiPath}export/content?taskId=${taskId}`;
  }

  /**
   * Get the public document url for download
   * @param {number} id The id of the documents
   */
  getPublicUrl(id: string) {
    return `${this.apiUrl}${this.apiPath}documentloc/get-raw/${id}`;
  }

  /**
   * Get the regulation url for download
   * @param {number} ambitoType The ambito type
   * @param {string} ambitoCode The ambito code
   * @param {string} planCode The plan code
   */
  getRegulationUrl(ambitoType: number, ambitoCode: string, planCode: string) {
    // FIXME

    return `${this.apiUrl}${this.apiPath}document/actual-ambito-norme-download?ambitoType=${ambitoType}&ambitoCode=${ambitoCode}&planCode=${planCode}`;
    // return `${this.apiUrl}${this.apiPath}document/actual-ambito-norme-download?ambitoType=${ambitoType}&ambitoCode=${ambitoCode}&planCode=${planCode}`;
  }
}
